import { useEffect } from 'react'

/**
 * Force a repaint of the body element to fix a bug in Safari PWAs where the
 * viewport height is not updated correctly when the page is hidden and
 * then shown again.
 */
export default function useUpdateVh() {
  useEffect(() => {
    const forceRepaint = () => {
      document.body.style.transform = 'translateZ(0)'
      setTimeout(() => {
        document.body.style.transform = ''
      }, 50)
    }
    window.addEventListener('pageshow', forceRepaint)
    window.addEventListener('focus', forceRepaint)
    return () => {
      window.removeEventListener('pageshow', forceRepaint)
      window.removeEventListener('focus', forceRepaint)
    }
  }, [])
}
